module.exports = __webpack_public_path__ + "img/Money.29647c2b.svg";